import { DateMaskEnum } from "common/enums/DateMaskEnum";
import moment from "moment";

export class ActionDate {
  readonly date: Date;
  readonly mask: DateMaskEnum;
  readonly day: number;
  readonly month: number;
  readonly year: number;

  constructor(date: Date, mask: DateMaskEnum) {
    this.date = date;
    this.mask = mask;
    this.day = this.date ? this.calculateDay(this.date.getDate(), mask) : 0;
    this.month = this.date
      ? this.calculateMonth(this.date.getMonth(), mask)
      : -1;
    this.year = this.date ? this.date.getFullYear() : -1;
  }

  /**
   * Formats the action date based on its masked date.
   * @param actionDate the action date to format to string
   * @returns the formatted date
   */
  static toString(actionDate: ActionDate): string {
    if (actionDate) {
      switch (actionDate.mask) {
        case DateMaskEnum.YYYY:
        case DateMaskEnum.YY:
          return moment(actionDate.date).format("YYYY");
        case DateMaskEnum.MMYYYY:
          return moment(actionDate.date).format("MM/YYYY");
        default:
          return moment(actionDate.date).format("DD/MM/YYYY");
      }
    } else {
      return "";
    }
  }

  /**
   * Calculates the day value taking into account the mask
   * @param day the given day value of the date object
   * @param mask the mask to take into account
   * @returns   the day value if the mask contains DD
   *            0 if the mask doesn't contain DD
   */
  private calculateDay(day: number, mask: DateMaskEnum): number {
    switch (mask) {
      case DateMaskEnum.YYYY:
      case DateMaskEnum.YY:
      case DateMaskEnum.MMYYYY:
        return 0;
      default:
        return day;
    }
  }

  /**
   * Calculates the month value taking into account the mask
   * @param month the given month value of the date object
   * @param mask the mask to take into account
   * @returns   the month value if the mask contains MM
   *            0 if the mask doesn't contain MM
   */
  private calculateMonth(month: number, mask: DateMaskEnum): number {
    switch (mask) {
      case DateMaskEnum.YY:
      case DateMaskEnum.YYYY:
        return -1;
      default:
        return month;
    }
  }
}
